<template>
  <div v-if="loaded">
    <div class="flex items-center space-x-5" v-if="ad.acceptance_status === $constants.AD_ACCEPTANCE_STATUSES.ACCEPTED">
      <img class="inline-block align-middle" width="24" height="24" src="@/assets/images/calibration.svg" alt="celebarate"/>
      <span>Accepted Ad.</span>
    </div>

    <div class="flex items-center space-x-5" v-if="ad.acceptance_status === $constants.AD_ACCEPTANCE_STATUSES.ON_HOLD">
      <vs-icon icon-pack="speakol" icon="speakol-unverify" color="#db2828"></vs-icon>
      <span>On hold ad.</span>
    </div>

    <div class="flex justify-between" v-if="ad.acceptance_status === $constants.AD_ACCEPTANCE_STATUSES.REJECTED">
      <div class="flex items-center space-x-5">
        <vs-icon icon-pack="speakol" icon="speakol-cancel" color="#db2828"></vs-icon>
        <span>Rejected ad.</span>
      </div>

      <div class="cursor-pointer text-speakol-color" @click="$emit('view-feedback')">
        View Feedback
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['ad'],
  data () {
    return {
      loaded: false
    }
  },

  async created () {
    this.loaded = true
  }
}
</script>
